import { SortingChannels } from 'constants/sorting'
import { StreamSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import React, { CSSProperties } from 'react'
import StoryTileConnected from 'sharedComponents/StoryTileConnected/StoryTileConnected'
import { FallbackSkeleton } from 'uiComponents/molecules/StoryTile/FallbackSkeleton'
import { HighlightTileRowContainer } from 'uiComponents/molecules/TileGrid/HighlightTiles'
import { Tile } from 'uiComponents/molecules/TileGrid/RowBuilder'
import { FCRow } from 'uiComponents/molecules/TileGrid/TileGrid'

function isNthRow(rowIndex: number, every: number) {
  return (rowIndex + 1) % every === 0
}

const HighlightRow: FCRow<{
  tiles: Tile[]
  rowIndex: number
  loading?: boolean
  style?: CSSProperties
}> = ({ tiles, rowIndex, loading, ...props }) => {
  const sortChannel = SortingChannels.UnSponsoredDefault
  const everyThirdRow = isNthRow(rowIndex, 3)
  const everySixthRow = isNthRow(rowIndex, 6)

  return (
    <HighlightTileRowContainer
      highlighted={everyThirdRow}
      reverseHighlight={everySixthRow}
      data-testid={everyThirdRow ? 'GridLarge' : 'GridSmall'}
      {...props}
    >
      <StreamSectionTrackingContextProvider
        sectionIndexOnPage={rowIndex}
        sortChannel={sortChannel}
      >
        {tiles.map((tile, index) => {
          if (!tile || !tile.id) {
            return <FallbackSkeleton key={index} />
          }

          const largeTile = everyThirdRow && index === 2

          return (
            <StoryTileConnected
              key={`story-${tile.id}`}
              data-testid="StoryTile"
              storyId={tile.id}
              importance={rowIndex === 0 ? 'high' : undefined}
              largeTile={largeTile}
            />
          )
        })}
      </StreamSectionTrackingContextProvider>
    </HighlightTileRowContainer>
  )
}

HighlightRow.calcHeight = ({ listWidth, tilesPerRow, rowProps }) => {
  const height = Math.round(listWidth / tilesPerRow)
  return tilesPerRow === 3 && isNthRow(rowProps?.rowIndex!, 3)
    ? height * 2
    : height
}

export default HighlightRow
